/** AUTO GENERATED FROM "node ./src/utils/build-icons.js". DO NOT TOUCH. * */
import React from 'react';
import classNames from 'classnames';

class Icon extends React.PureComponent {
  render() {
    const { className, svgRef, ...otherProps } = this.props;
    return (
      <svg
        width="85.55"
        height="81.77"
        viewBox="0 0 85.55 81.77"
        fill="currentColor"
        className={classNames('nmx-icon', className)}
        ref={svgRef}
        {...otherProps}>
        <path
          fill="#fff"
          d="M42.81 0a40.69 40.69 0 0 1 40.72 40.66 1.25 1.25 0 0 1-2.5 0 38.2 38.2 0 0 0-75.64-7.69 1.25 1.25 0 0 1-1.48 1 1.24 1.24 0 0 1-.84-.62l-.06-.12-2.89-7a1.25 1.25 0 1 1 2.26-1.07l.06.11 1.44 3.51v-.15A40.72 40.72 0 0 1 42.23.01Z"
          className="icon-fill icon-base"/>
        <path
          fill="#fff"
          d="M9.61 27.69a1.25 1.25 0 0 1 1.45 2l-.11.08-6.25 3.94a1.25 1.25 0 0 1-1.44-2l.11-.08ZM2.81 39.83a1.25 1.25 0 0 1 1.25 1.25 38.2 38.2 0 0 0 75.61 7.7 1.25 1.25 0 0 1 2.3-.4l.06.11 3.39 6.72a1.25 1.25 0 0 1-2.17 1.24l-.07-.12-1.87-3.71a40.7 40.7 0 0 1-38.46 29.17h-.58A40.7 40.7 0 0 1 1.55 41.11a1.25 1.25 0 0 1 1.25-1.25Z"
          className="icon-fill icon-base"/>
        <path
          fill="#fff"
          d="M80.36 48.03a1.25 1.25 0 0 1 1.44 2l-.11.08-6.24 3.94a1.25 1.25 0 0 1-1.45-2l.11-.08Z"
          className="icon-fill icon-base"/>
        <path
          fill="#ffb81c"
          d="M39.47 12.58v4.92l-.76.14-.77.15A11.79 11.79 0 0 0 29.06 25a14.78 14.78 0 0 0-1 6.71 11.5 11.5 0 0 0 6.15 9.79 48.69 48.69 0 0 0 5.16 2.32c2.16.91 4.36 1.74 6.51 2.66a3.93 3.93 0 0 1 2.46 4.29c-.16 2.12-1.15 3.79-3.45 4.3a12.48 12.48 0 0 1-2.73.3 6.78 6.78 0 0 1-6.93-5.06c-.2-.61-.34-1.23-.53-1.89l-8.24 2.12a17.12 17.12 0 0 0 4 8.16 13.87 13.87 0 0 0 9 4.16v6.37h5.33v-6.29c1.07-.22 2.11-.38 3.12-.64a12.24 12.24 0 0 0 8.67-7 14.32 14.32 0 0 0 1-8.59 11.29 11.29 0 0 0-5.74-8.21 61.39 61.39 0 0 0-7.89-3.45c-1.61-.64-3.19-1.39-4.75-2.15a3.45 3.45 0 0 1-1.77-2.15 4.81 4.81 0 0 1 3.19-6l.18-.05a5.6 5.6 0 0 1 5.51 1.44 10.4 10.4 0 0 1 2.22 3.37c.18.4.35.81.53 1.25l7.38-3a15 15 0 0 0-2.71-5.56 13 13 0 0 0-9-4.66v-4.96Z"
          className="icon-fill icon-accent"
          fillRule="evenodd"/>
      </svg>

    );
  }
}

Icon.displayName = 'DollarSignRevolvingArrowsIcon';

export default Icon;
